
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SalesInvoiceYearToDateCombined"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dimension"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalysisDimension"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"measure"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalysisMeasure"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"measure2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalysisMeasure"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"measure3"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalysisMeasure"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"financialCalendar"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialCalendarInput"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dimensionFilters"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DimensionFilterInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"salesInvoiceYearToDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"breakdownDimension"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimension"}}},{"kind":"Argument","name":{"kind":"Name","value":"measure"},"value":{"kind":"Variable","name":{"kind":"Name","value":"measure"}}},{"kind":"Argument","name":{"kind":"Name","value":"financialCalendar"},"value":{"kind":"Variable","name":{"kind":"Name","value":"financialCalendar"}}},{"kind":"Argument","name":{"kind":"Name","value":"dimensionFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimensionFilters"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dimensionId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"data2"},"name":{"kind":"Name","value":"salesInvoiceYearToDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"breakdownDimension"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimension"}}},{"kind":"Argument","name":{"kind":"Name","value":"measure"},"value":{"kind":"Variable","name":{"kind":"Name","value":"measure2"}}},{"kind":"Argument","name":{"kind":"Name","value":"financialCalendar"},"value":{"kind":"Variable","name":{"kind":"Name","value":"financialCalendar"}}},{"kind":"Argument","name":{"kind":"Name","value":"dimensionFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimensionFilters"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dimensionId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"data3"},"name":{"kind":"Name","value":"salesInvoiceYearToDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"breakdownDimension"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimension"}}},{"kind":"Argument","name":{"kind":"Name","value":"measure"},"value":{"kind":"Variable","name":{"kind":"Name","value":"measure3"}}},{"kind":"Argument","name":{"kind":"Name","value":"financialCalendar"},"value":{"kind":"Variable","name":{"kind":"Name","value":"financialCalendar"}}},{"kind":"Argument","name":{"kind":"Name","value":"dimensionFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimensionFilters"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dimensionId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":993}};
    doc.loc.source = {"body":"query SalesInvoiceYearToDateCombined(\n  $dimension: AnalysisDimension\n  $measure: AnalysisMeasure\n  $measure2: AnalysisMeasure\n  $measure3: AnalysisMeasure\n  $financialCalendar: FinancialCalendarInput\n  $dimensionFilters: [DimensionFilterInput]\n) {\n  data: salesInvoiceYearToDate(\n    breakdownDimension: $dimension\n    measure: $measure\n    financialCalendar: $financialCalendar\n    dimensionFilters: $dimensionFilters\n  ) {\n    uuid\n    reference\n    description\n    dimensionId\n    value\n  }\n  data2: salesInvoiceYearToDate(\n    breakdownDimension: $dimension\n    measure: $measure2\n    financialCalendar: $financialCalendar\n    dimensionFilters: $dimensionFilters\n  ) {\n    uuid\n    reference\n    description\n    dimensionId\n    value\n  }\n  data3: salesInvoiceYearToDate(\n    breakdownDimension: $dimension\n    measure: $measure3\n    financialCalendar: $financialCalendar\n    dimensionFilters: $dimensionFilters\n  ) {\n    uuid\n    reference\n    description\n    dimensionId\n    value\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SalesInvoiceYearToDateCombined"] = oneQuery(doc, "SalesInvoiceYearToDateCombined");
        
